<template>
  <div>
    <apexchart height="350" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import { CommunityService } from "@/services";

export default {
  name: "piechart",
  data: () => ({
    series: [],
    chartOptions: {
      title: {
        text: "Communities",
        align: "left",
        margin: 0,
        style: {
          fontSize: "19px",
          fontWeight: "bold",
          color: "#344452",
        },
      },
      chart: {
        type: "pie",
        fontFamily: "Now Alt",
      },
      noData: {
        text: 'Loading...'
      },
      colors: ["#A6CEE3", "#1F78B4", "#B2DF8A"],
      legend: {
        show: true,
        position: "top",
        floating: false,
        fontSize: "16px",
        fontWeight: 400,
        horizontalAlign: "center",
        offsetY: 5,
        offsetX: 0,
        markers: {
          width: 15,
          height: 15,
          radius: 0,
        },
      },
      labels: ["Active", "Pending", "New"],
    },
  }),
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      const chartData = await CommunityService.getPieChart();
      for (var i = 0; i < chartData.data.length; i++) {
        this.series.push(chartData.data[i].count);
        this.series.reverse();
      }
    },
  },
};
</script>